export { default } from 'cccisd-game-zoou-ini0';
